import { render, staticRenderFns } from "./ElliotWaveSchool.vue?vue&type=template&id=e6612b76&scoped=true&"
import script from "./ElliotWaveSchool.vue?vue&type=script&lang=js&"
export * from "./ElliotWaveSchool.vue?vue&type=script&lang=js&"
import style0 from "./ElliotWaveSchool.vue?vue&type=style&index=0&id=e6612b76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6612b76",
  null
  
)

export default component.exports